import { render } from "./App.vue?vue&type=template&id=6200322a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6200322a&lang=sass"
script.render = render

export default script